export default [
  {
    path: "/",
    title: "Home",
  },

  {
    path: "/projects",
    title: "projects",
  },
  {
    path: "/about",
    title: "CV",
  },

  // {
  //   path: "/contact",
  //   title: "contact",
  // },
];
